import FeaturedToys from '../components/FeaturedToys'
import YourToys from '../components/YourToys'
import MakeYourOwnToy from '../components/MakeYourOwnToy'

export default function Toys() {
  return (
    <>
      <h1 className="page-title">
        Toys <em className="wink">for all</em>.
      </h1>
      <p className="page-lede">
        Pocket-sized activities to load onto your Oroblanco One pad.
      </p>
      <FeaturedToys />
      <YourToys />
      <MakeYourOwnToy />
    </>
  )
}
